/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_Point_4Inputs */

const en_outside_point_4 = /** @type {(inputs: Outside_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude reads Nexxt through MCP, with the user's own permissions`)
};

/**
* | output |
* | --- |
* | "Claude reads Nexxt through MCP, with the user's own permissions" |
*
* @param {Outside_Point_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_point_4 = /** @type {((inputs?: Outside_Point_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_Point_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_point_4(inputs)
});